import { render, staticRenderFns } from "./uploadPicture.vue?vue&type=template&id=50344067&scoped=true&"
import script from "./uploadPicture.vue?vue&type=script&lang=js&"
export * from "./uploadPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50344067",
  null
  
)

export default component.exports